// No longer in use for now, using cognito & AuthProvider.jsx component

import { createSlice } from '@reduxjs/toolkit'

import { getLoginToken } from '@services/local-storage.utils'

const LOGIN_TOKEN = getLoginToken()

const initialState = {
  user: LOGIN_TOKEN ? { token: LOGIN_TOKEN } : null,
}

const login = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
  },
})

export const { setUser } = login.actions

export default login.reducer
